export default [
  {
    path: 'M64 64m102.4 0l691.2 0q102.4 0 102.4 102.4l0 691.2q0 102.4-102.4 102.4l-691.2 0q-102.4 0-102.4-102.4l0-691.2q0-102.4 102.4-102.4Z',
    fill: '#2E001F',
  },
  {
    path: 'M857.6 983.04H166.4a125.5808 125.5808 0 0 1-125.44-125.44V166.4a125.5808 125.5808 0 0 1 125.44-125.44h691.2a125.5808 125.5808 0 0 1 125.44 125.44v691.2a125.5808 125.5808 0 0 1-125.44 125.44zM166.4 87.04a79.4496 79.4496 0 0 0-79.36 79.36v691.2a79.4496 79.4496 0 0 0 79.36 79.36h691.2a79.4496 79.4496 0 0 0 79.36-79.36V166.4a79.4496 79.4496 0 0 0-79.36-79.36z',
    fill: '#FF26BE',
  },
  {
    path: 'M202.752 305.408H279.04l82.944 129.024 86.528-129.024h71.68L399.36 481.536l129.536 189.44h-77.824L359.936 531.2l-92.672 139.776h-73.216l129.536-189.44zM807.4112 670.976H752.128v-35.84h-1.024c-15.36 30.208-48.64 43.008-81.92 43.008-83.456 0-123.904-61.952-123.904-141.312 0-95.744 56.832-137.728 114.688-137.728 33.28 0 70.144 12.288 88.064 41.472h1.024V305.408h58.368z m-130.56-38.912c52.224 0 74.24-47.616 74.24-93.696 0-58.368-28.16-93.184-73.216-93.184-54.784 0-74.24 48.64-74.24 96.256 0.0128 45.568 22.5408 90.624 73.2288 90.624z',
    fill: '#FFD9F2',
  },
]
